module.exports = __webpack_public_path__ + "img/logo.45f4dc2d.gif";